/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { graphql, useFragment } from 'react-relay';
import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import type { breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs$key } from '@atlassian/jira-relay/src/__generated__/breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs.graphql';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { Tokens } from '@atlassian/jira-custom-theme-constants/src/constants.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const createProjectUrl = (projectKey: string) => `/browse/${encodeURIComponent(projectKey)}`;

export const HorizontalNavProjectBreadcrumbs = ({
	projectFragment,
	shouldShowProjectName = false,
}: {
	projectFragment: breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs$key | null;
	shouldShowProjectName?: boolean;
}) => {
	const project = useFragment(
		graphql`
			fragment breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs on JiraProject {
				key
				name
			}
		`,
		projectFragment,
	);

	const { formatMessage } = useIntl();

	return (
		<div css={breadcrumbStyles}>
			<Breadcrumbs>
				<BreadcrumbsItem href="/jira/projects" text={formatMessage(messages.projectsTitle)} />
				{shouldShowProjectName && project && (
					<BreadcrumbsItem href={createProjectUrl(project?.key)} text={project?.name} />
				)}
			</Breadcrumbs>
		</div>
	);
};

const breadcrumbStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minHeight: `${gridSize * 3}px`,
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	'--ds-text-subtle': Tokens.COLOR_TEXT_SUBTLE,
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	'--ds-text-subtlest': Tokens.COLOR_TEXT_SUBTLEST,
});
